// src/components/MapGpsButton.jsx
import { IconButton } from "@chakra-ui/react";
import { FiNavigation } from "react-icons/fi";

export default function MapGpsButton({ onLocate }) {
  return (
    <IconButton
      icon={<FiNavigation />}
      aria-label="Locate Me"
      position="absolute"
      bottom="80px"
      right="16px"
      zIndex={40}
      colorScheme="red"
      borderRadius="full"
      size="lg"
      shadow="lg"
      onClick={onLocate}
    />
  );
}
